import { render, staticRenderFns } from "./ResidentGroupMemberEdit.vue?vue&type=template&id=50a731ee&scoped=true&lang=pug"
import script from "./ResidentGroupMemberEdit.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupMemberEdit.vue?vue&type=script&lang=ts"
import style0 from "./ResidentGroupMemberEdit.vue?vue&type=style&index=0&id=50a731ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a731ee",
  null
  
)

export default component.exports